<template>
  <div
    :class="[
      'inline-block font-semibold rounded',
      statusClass,
      large ? 'px-4 py-2' : 'text-sm p-2',
    ]"
  >
    {{ status }}
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
      default: 'Dostępne',
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusClass() {
      switch (this.status) {
        case 'Dostępne':
        case 'Dostępny':
          return 'bg-green-500 text-white';
        case 'Sprzedany':
        case 'Sprzedane':
          return 'bg-red-500 text-white';
        case 'Rezerwacja':
        case 'Zarezerwowany':
          return 'bg-orange-500 text-white';
        case 'Niedostępny':
        case 'Wkrótce':
        case 'Wkrótce w sprzeday':
          return 'bg-gray-300 text-gray-500';
      }
    },
  },
};
</script>
